import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
const routes: Routes = [
	{path: '**', component: PageNotFoundComponent},
	{path: 'page-not-found', component: PageNotFoundComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PageNotFoundRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/page-not-found/page-not-found-routing.module.ts